<template>
    <a-drawer :title="title" width="600" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="期次信息" bordered :column="1" size="middle">
            <a-descriptions-item label="期次名称">
                {{ detail.name }}
            </a-descriptions-item>
            <a-descriptions-item label="期次编号">
                {{ detail.sno }}
            </a-descriptions-item>
            <a-descriptions-item label="报名人数">
                {{ detail.regs }}
            </a-descriptions-item>
            <a-descriptions-item label="实到人数">
                {{ detail.real }}
            </a-descriptions-item>
            <a-descriptions-item label="考核人数">
                {{ detail.auct }}
            </a-descriptions-item>
            <a-descriptions-item label="通过人数">
                {{ detail.pass }}
            </a-descriptions-item>
            <a-descriptions-item label="开始日期">
                {{ detail.start }}
            </a-descriptions-item>
            <a-descriptions-item label="结束日期">
                {{ detail.end }}
            </a-descriptions-item>
            <a-descriptions-item label="截至日期">
                {{ detail.closing }}
            </a-descriptions-item>
            <a-descriptions-item label="优惠金额">
                {{ detail.dis }}
            </a-descriptions-item>
            <a-descriptions-item label="奖学金">
                {{ detail.award }}
            </a-descriptions-item>
            <a-descriptions-item label="组织单位">
                {{ detail.orgunit }}
            </a-descriptions-item>
            <a-descriptions-item label="开班地点">
                {{ detail.addr }}
            </a-descriptions-item>
            <a-descriptions-item label="备注说明">
                {{ detail.memo }}
            </a-descriptions-item>
            <a-descriptions-item label="联系人">
                {{ detail.linker }}
            </a-descriptions-item>
            <a-descriptions-item label="联系电话">
                {{ detail.linktel }}
            </a-descriptions-item>
            <a-descriptions-item label="佣金方式">
                {{ detail.brot === 'Rate' ? '比例金额' : '固定金额' }}
            </a-descriptions-item>
            <a-descriptions-item label="固定金额">
                {{ detail.broa }}
            </a-descriptions-item>
            <a-descriptions-item label="比例金额">
                {{ detail.bror }}
            </a-descriptions-item>
        </a-descriptions>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            detail: {
                cta: {},
                course: {}
            }
        }
    },
    mounted() {
        this.$http
            .get('/crs/train/classes/detail', {
                params: {
                    id: this.item.id
                }
            })
            .then(result => {
                this.detail = result.data
            })
    }
}
</script>
